import React from 'react';

export function Panel({ children, className = '', thin = false, ...rest }) {
  return (
    <div className={`${thin ? 'h-panel-thin' : 'h-panel'} ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function SectionDivider({ label }) {
  return (
    <div className="flex items-center justify-center gap-4 my-10">
      <div className="h-px flex-1 max-w-[180px]" style={{ background: 'rgba(75,24,56,0.35)' }} />
      {label && <span className="h-eyebrow">{label}</span>}
      <div className="h-px flex-1 max-w-[180px]" style={{ background: 'rgba(75,24,56,0.35)' }} />
    </div>
  );
}
